// src/oktaConfig.js
const commonConfig = {
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
  pkce: true,
  scopes: ["openid", "email", "profile"],
  grant_type: "authorization_code",
  responseType: ["token", "id_token"],
  tokenManager: { storage: 'sessionStorage' }
};

export const oktaConfigs = {
  emea: {
    issuer: 'https://euhitachi.okta-emea.com/oauth2/default',
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oagf96w5e9whWcMG0i7',
    ...commonConfig
  },
  hal: {
    issuer: 'https://myhitachi.okta.com/oauth2/default',
    clientId: process.env.REACT_APP_HAL_OKTA_CLIENT_ID || '0oa17wbqgeczwpJl71t8',
    ...commonConfig
  },
  vantara: {
    issuer: process.env.REACT_APP_VANTARA_OKTA_ISSUER,
    clientId: process.env.REACT_APP_VANTARA_OKTA_CLIENT_ID,
    ...commonConfig
  },
  digital: {
    issuer: process.env.REACT_APP_DIGITAL_OKTA_ISSUER,
    clientId: process.env.REACT_APP_DIGITAL_OKTA_CLIENT_ID,
    ...commonConfig
  },
  hds: {
    issuer: process.env.REACT_APP_HDS_OKTA_ISSUER,
    clientId: process.env.REACT_APP_HDS_OKTA_CLIENT_ID,
    ...commonConfig
  },
  global: {
    issuer: process.env.REACT_APP_GLOBAL_OKTA_ISSUER,
    clientId: process.env.REACT_APP_GLOBAL_OKTA_CLIENT_ID,
    ...commonConfig
  }
};

export const getOktaConfig = (type) => {
  return oktaConfigs[type] || oktaConfigs.emea;
};